// Keys de features que dependen de capacidades nativas.
// Componentes consultan useFeatureGate(key) para saber si mostrar la feature.
export const FEATURE_BIOMETRIC_LOGIN = 'BIOMETRIC_LOGIN';
export const FEATURE_BIOMETRIC_SETUP = 'BIOMETRIC_SETUP';
export const FEATURE_PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS';
export const FEATURE_APP_UPDATE = 'APP_UPDATE';
export const FEATURE_FINSUS = 'FINSUS';
// Registro (vincular cuenta de cliente existente): todas las plataformas.
export const FEATURE_REGISTRATION = 'REGISTRATION';
// Alta de cliente nuevo + validación de identidad (KYC): solo celular real.
export const FEATURE_REGISTRATION_NEW_CLIENT = 'REGISTRATION_NEW_CLIENT';
